<template>
  <span>{{ entryGrade }}</span>
</template>

<script>
import { getGradeLabel } from "@/features/schools/services";

export default {
  name: "EntryGrade",
  props: {
    data: {
      type: [Number, String],
    },
  },
  computed: {
    entryGrade() {
      return getGradeLabel(this.data) || "";
    },
  },
};
</script>
